// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260202-1/static/css/" + chunkId + "." + "b8bbe441" + ".chunk.css";
};